export default "__VITE_ASSET__DigaExWl__"